import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { aiAgentAsyncDynamicPromptsAppGroupId } from "./constants";
import type {
  PostwsAiAgentAsyncDynamicPromptsAppGroupIdPayload,
  PostwsAiAgentAsyncDynamicPromptsAppGroupIdProps,
} from "./types";
import { isAsyncAiDynamicPromptsResult } from "./validators";

export const postwsAiAgentAsyncDynamicPromptsAppGroupId = reactQueryPostWebsocketAdapter(
  aiAgentAsyncDynamicPromptsAppGroupId,
  async (signal, { appGroupId, args, jobToken }: PostwsAiAgentAsyncDynamicPromptsAppGroupIdProps): Promise<{}> => {
    const payload: PostwsAiAgentAsyncDynamicPromptsAppGroupIdPayload = {
      job_token: jobToken,
      args,
    };

    return await fetch(`/ai_agent/async_dynamic_prompts/${appGroupId}`, "POST", payload, { signal });
  },
  isAsyncAiDynamicPromptsResult
);
